<template>
  <div v-if="debugModeOn && isDebugAdmin" class="debug-window elevation-8">
    <div v-for="[key, value] in debugRefList" class="debug-window-row">
      <strong class="debug-label">{{ key }}: </strong><span class="debug-value">{{ value }}</span>
      <cp-btn :text="unref(value)" />
    </div>
  </div>
</template>

<script setup>
import { unref } from "vue";
import { storeToRefs } from "pinia";
import { useRootStore } from "../../stores/root";
import { useDebugStore } from "../../stores/debug";
import CpBtn from "./CpBtn.vue";

const store = useRootStore();
const { orgId, userId } = storeToRefs(store);

const debugStore = useDebugStore();
const { debugModeOn, debugRefList, isDebugAdmin } = storeToRefs(debugStore);
</script>

<style scoped>
.debug-window {
  position: fixed;
  color: white;
  right: 10px;
  bottom: 10px;
  padding: 24px;
  border: 1px solid gray;
  background-color: rgba(0, 0, 0, 0.7);
}

.debug-window-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
}

.debug-label {
  font-size: 14px;
}

.debug-value {
  font-size: 12px;
}
</style>
